import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { withEnvGuard } from '@traton/devportal-env-kit-app';

import { AgenticMarketplaceClient } from './api/AgenticMarketplaceClient';
import { agenticMarketplaceApiRef } from './api/AgenticMarketplaceApi';
import { rootRouteRef } from './routes';

export const agenticMarketplacePlugin = createPlugin({
  id: 'agentic-marketplace',
  apis: [
    createApiFactory({
      api: agenticMarketplaceApiRef,
      deps: {
        identityApi: identityApiRef,
      },
      factory: ({ identityApi }) =>
        new AgenticMarketplaceClient({ identityApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AgenticMarketplacePage = agenticMarketplacePlugin.provide(
  createRoutableExtension({
    name: 'AgenticMarketplacePage',
    component: () =>
      import('./components/AgenticMarketplacePage').then(m =>
        withEnvGuard(m.AgenticMarketplacePage, 'agentic-marketplace'),
      ),
    mountPoint: rootRouteRef,
  }),
);
